export const data = [{
    image: 'https://i.ibb.co/CKG0Gbr/frontend.png',
    title: 'Front End Development',
    body: 'I can development pixel perfect web application using HTML5, CSS3 and JavaScript from PSD or Figma file. You can check my project section and github profile to see my work.'
},
{
    image: 'https://i.ibb.co/zrkgdGH/react.png',
    title: 'React Development',
    body: 'I can build single page web applications using react. React is developed by Facebook which is a lighth weight javascript framework that is used to create lightening fast web applications. My react projects are live on netlify.'
},
{
    image: 'https://i.ibb.co/BP20pH4/bootstrap.png',
    title: 'Front end design via Bootstrap',
    body: 'I can use Bootstrap to create web design quickly. I have several bootstrap projects which is availabe to display my ability to use bootstrap to design web applications.'
},
{
    image: 'https://i.ibb.co/D5SL1wN/tailwind.png',
    title: 'Front end design via Tailwind',
    body: 'Tailwind is low level CSS framework that allow us to design web site without writing a single line of css. In most of my projects i use tailwind css to design website.'
},
{
    image: 'https://i.ibb.co/THK1gv7/nodejs.png',
    title: 'Backend Server using NodeJs',
    body: 'Node js is a backend javascript run time environment that allow us to run javascript code outside browser. I can create back end server using node js and express.'
},
{
    image: 'https://i.ibb.co/dcCYwPW/mongodb.png',
    title: 'MongoDB Database',
    body: 'MongoDB is type of nosql database that provide json like data set. It is very popular to use with NodeJS, Express and React also knowns as MERN (MongoDB, Express, Node and React) stack. I can build MERN application from sctatch.'
},
]